import { GiftState } from "./types";

const GIFT_KEY = "gifts";

export function getGiftState(): GiftState {
  try {
    const item = window.localStorage.getItem(GIFT_KEY);

    if (!item) {
      return {};
    }

    return JSON.parse(item);
  } catch (err) {
    console.log(`Unable to get ${GIFT_KEY} from local storage`, err);
    return {};
  }
}

export function setGiftState(item: GiftState) {
  try {
    window.localStorage.setItem(GIFT_KEY, JSON.stringify(item));
  } catch (err) {
    console.log(`Unable to set ${GIFT_KEY} in local storage`, err);
  }
}

export function updateGiftState(updates: Partial<GiftState>) {
  const item = getGiftState();

  return setGiftState({
    ...item,
    ...updates
  });
}
